import { BaseRequestQueryParam, HttpResponse } from 'models';
import {
  ChatMessageType,
  FileUploadList,
  GiveAwayResponseModel,
  LikeMessageRequest,
  MessageResponseType,
} from 'models/chatMessage';
import { getLocalStorage } from 'utils/sessionStorage';
import axiosClient, { handleRequest } from './axiosClient';
import { ShareTweetRequestDto, ShareTweetResponseDto } from 'models/user';

const chatApi = {
  getMessages: (params: BaseRequestQueryParam): Promise<HttpResponse<MessageResponseType>> => {
    const url = `/chat/api/messages`;
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  deleteMessage: (messageId: string) => {
    const url = `/chat/api/admin/chat-room/${messageId}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getAssistantMessages: (): Promise<HttpResponse<ChatMessageType[]>> => {
    const url = `/chat/api/messages/assistant`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  shareTwitter: (request: ShareTweetRequestDto): Promise<HttpResponse<ShareTweetResponseDto>> => {
    const url = `/chat/api/twitter/share`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  uploadFile: (files: FileUploadList[], replyOnId: string) => {
    const url = `/chat/api/upload-file`;
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file.content));
    formData.append('replyOnId', replyOnId || '');

    return handleRequest(
      axiosClient.post(url, formData, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
          'Content-Type': 'multipart/form-data',
        },
      }),
    );
  },
  getGiveAwayList: (): Promise<HttpResponse<GiveAwayResponseModel[]>> => {
    const url = `/chat/api/give-away`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getSpinAndDrop: (): Promise<HttpResponse<GiveAwayResponseModel[]>> => {
    const url = `/chat/api/give-away/spin-drop`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  likeChat: (request: LikeMessageRequest) => {
    const url = `/chat/api/messages/like`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default chatApi;
